/**
 * カート商品行に出す文言。ホストによる語彙の違いはこの層で吸収する。
 */
export interface CartItemMessageUiText {
  outOfStock: string
  soldOut: string
  restockRequestAccepted: string
}

interface CartItemMessageUiTextEnvironment {
  readonly isLikeHotellovers: boolean
}

export const defaultCartItemMessageUiText: CartItemMessageUiText = {
  outOfStock: '売り切れのためご購入いただけません',
  soldOut: 'SOLD OUT',
  restockRequestAccepted: '再入荷リクエスト受付中',
}

const hotelloversCartItemMessageUiText: CartItemMessageUiText = {
  ...defaultCartItemMessageUiText,
  restockRequestAccepted: '入荷通知受付中',
}

export function createCartItemMessageUiText(
  environment: CartItemMessageUiTextEnvironment
): CartItemMessageUiText {
  if (environment.isLikeHotellovers) {
    return hotelloversCartItemMessageUiText
  }

  return defaultCartItemMessageUiText
}
